import React from 'react';
import PropTypes from 'prop-types';
import Translate from '@securitize/ui-components/i18n/Translate';
import {
  Button, Modal, ModalBody, ModalHeader,
} from 'reactstrap';
import pending from './pending.svg';
import './ProcessingVerificationModal.scss';

const ProcessingVerificationModal = (props) => {
  const { isOpen, onToggle } = props;

  return (
    <Modal
      isOpen={isOpen}
      toggle={onToggle}
      centered
      zIndex={10000}
      className="processing-verification-modal"
    >
      <ModalHeader
        toggle={onToggle}
        tag="div"
        className="w-100 flex-column-reverse align-items-center border-0 p-0"
      />
      <ModalBody className="p-0 pt-4 d-flex flex-column align-items-center justify-content-center">
        <img src={pending} alt="processing" />
        <div className="text-center font-20 font-weight-bolder mt-5">
          <Translate translationKey="Texts.processing-verification-title" />
        </div>
        <div className="font-16 mt-4 text-center"><Translate translationKey="Texts.processing-verification-text" /></div>
        <Button
          className="mt-5"
          color="link"
          size="lg"
          block
          onClick={onToggle}
        >
          <Translate translationKey="Texts.processing-verification-close" />
        </Button>
      </ModalBody>
    </Modal>
  );
};

ProcessingVerificationModal.defaultProps = {
  isOpen: false,
  onToggle: () => undefined,
};

ProcessingVerificationModal.propTypes = {
  isOpen: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default ProcessingVerificationModal;
